<!--
~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
-->

@if (small !== null) {
  @if (!multiselect) {
    <ngf-single-select small [showOverflowTooltip]="showOverflowTooltip" [ariaLabel]="ariaLabel" [ariaLabelledby]="ariaLabelledby" [ariaDescribedby]="ariaDescribedby" />
  }
  @if (multiselect) {
    <ngf-multi-select small [legacyMultiselect]="legacyMultiselect" [ariaLabel]="ariaLabel" [ariaLabelledby]="ariaLabelledby" [ariaDescribedby]="ariaDescribedby" />
  }
}

@if (small === null) {
  @if (!multiselect) {
    <ngf-single-select [showOverflowTooltip]="showOverflowTooltip" [ariaLabel]="ariaLabel" [ariaLabelledby]="ariaLabelledby" [ariaDescribedby]="ariaDescribedby" />
  }
  @if (multiselect) {
    <ngf-multi-select [legacyMultiselect]="legacyMultiselect" [ariaLabel]="ariaLabel" [ariaLabelledby]="ariaLabelledby" [ariaDescribedby]="ariaDescribedby" />
  }
}


<ngf-options-overlay [triggerRef]="elementRef" [disabled]="disabled" [readonly]="isReadonly">
  <ng-content select="ngf-options-container" />
  <ng-content select="ngf-options-search-container" />
</ngf-options-overlay>
